(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["mf-gallery-loop"] && !Shopify.designMode) return;
  try {
    (() => {
  const initialise = async () => {
    await customElements.whenDefined('scroll-carousel');
    document.querySelectorAll('.shopify-section--main-product product-gallery scroll-carousel').forEach(carousel => {
      if (carousel.dataset.mfLoop) return;
      carousel.dataset.mfLoop = 'true';
      const gallery = carousel.closest('product-gallery');
      const cells = () => [...carousel.children].filter(cell => !cell.hidden);
      const currentIndex = () => {
        const rect = carousel.getBoundingClientRect();
        const centre = rect.left + rect.width / 2;
        let closest = 0;
        let distance = Infinity;
        cells().forEach((cell,index) => {
          const box = cell.getBoundingClientRect();
          const delta = Math.abs(box.left + box.width / 2 - centre);
          if (delta < distance) { closest = index; distance = delta; }
        });
        return closest;
      };
      const main = gallery.closest('.shopify-section--main-product');
      let wrapping = false;
      const wrap = (target, direction) => {
        if (wrapping) return;
        if (matchMedia('(prefers-reduced-motion: reduce)').matches) {
          carousel.select(target, {instant:true});
          return;
        }
        const slides = cells();
        const from = slides[currentIndex()];
        const to = slides[target];
        const frame = carousel.parentElement;
        const bounds = carousel.getBoundingClientRect();
        const frameBounds = frame.getBoundingClientRect();
        const makeVisual = cell => {
          const source = cell.querySelector('img');
          const poster = cell.querySelector('video')?.poster;
          if (!source && !poster) return null;
          const img = source ? source.cloneNode(false) : document.createElement('img');
          if (!source) img.src = poster;
          img.removeAttribute('id');
          img.removeAttribute('srcset');
          img.removeAttribute('sizes');
          if (source) img.src = source.currentSrc || source.src;
          img.alt = '';
          img.loading = 'eager';
          const style = getComputedStyle(source || cell);
          img.style.cssText = 'position:absolute;inset:0;width:100%;height:100%;max-height:none;max-width:none;margin:0;aspect-ratio:auto;';
          img.style.objectFit = source ? style.objectFit : 'contain';
          img.style.objectPosition = source ? style.objectPosition : 'center';
          return img;
        };
        const outgoing = makeVisual(from);
        const incoming = makeVisual(to);
        if (!outgoing || !incoming || !bounds.width) {
          carousel.select(target, {instant:true});
          return;
        }
        wrapping = true;
        const overlay = document.createElement('div');
        overlay.setAttribute('aria-hidden','true');
        overlay.style.cssText = 'position:absolute;overflow:hidden;pointer-events:none;z-index:1;';
        overlay.style.left = (bounds.left - frameBounds.left) + 'px';
        overlay.style.top = (bounds.top - frameBounds.top) + 'px';
        overlay.style.width = bounds.width + 'px';
        overlay.style.height = bounds.height + 'px';
        overlay.style.background = getComputedStyle(from).backgroundColor;
        overlay.append(outgoing,incoming);
        frame.append(overlay);
        const sign = (getComputedStyle(carousel).direction === 'rtl' ? -1 : 1) * direction;
        const options = {duration:320,easing:'cubic-bezier(.25,.46,.45,.94)',fill:'forwards'};
        const exit = outgoing.animate([{transform:'translateX(0)'},{transform:'translateX(' + (-sign * 100) + '%)'}],options);
        const enter = incoming.animate([{transform:'translateX(' + (sign * 100) + '%)'},{transform:'translateX(0)'}],options);
        carousel.select(target, {instant:true});
        Promise.allSettled([exit.finished,enter.finished]).then(() => {
          if (carousel.isConnected && cells()[target] === to) carousel.select(target, {instant:true});
          overlay.remove();
          wrapping = false;
        });
      };
      const preloadEnds = () => {
        const slides = cells();
        [slides[0],slides[slides.length - 1]].forEach(cell => {
          cell?.querySelectorAll('img').forEach(img => { img.loading = 'eager'; });
        });
      };
      preloadEnds();
      carousel.addEventListener('carousel:filter',preloadEnds);
      if (!main.dataset.mfLoopObserver) {
        main.dataset.mfLoopObserver = 'true';
        new MutationObserver(() => {
          if (main.querySelector('product-gallery scroll-carousel:not([data-mf-loop])')) initialise();
        }).observe(main, {childList:true,subtree:true});
      }
      const move = direction => {
        if (wrapping) return;
        const count = cells().length;
        if (count < 2) return;
        const index = currentIndex();
        const target = (index + direction + count) % count;
        const wraps = (index === 0 && direction < 0) || (index === count - 1 && direction > 0);
        if (wraps) wrap(target,direction);
        else carousel.select(target, {instant:matchMedia('(prefers-reduced-motion: reduce)').matches});
      };
      carousel.next = () => move(1);
      carousel.previous = () => move(-1);
      const enableButtons = () => {
        gallery.querySelectorAll('carousel-prev-button button,carousel-next-button button').forEach(button => {
          button.disabled = cells().length < 2;
        });
      };
      carousel.addEventListener('scroll:edge-nearing', event => {
        event.stopImmediatePropagation();
        enableButtons();
      }, true);
      carousel.addEventListener('scroll:edge-leaving', event => {
        event.stopImmediatePropagation();
        enableButtons();
      }, true);
      carousel.addEventListener('carousel:filter', enableButtons);
      enableButtons();
      let start = null;
      let boundarySwipe = false;
      carousel.addEventListener('touchstart', event => {
        boundarySwipe = false;
        start = null;
        if (wrapping || event.touches.length !== 1 || cells().length < 2 ||
            carousel.scrollWidth <= carousel.clientWidth + 2 ||
            event.target.closest('button,a,input,video,iframe,model-viewer')) return;
        const index = currentIndex();
        start = {
          x:event.touches[0].clientX,
          y:event.touches[0].clientY,
          first:index === 0,
          last:index === cells().length - 1,
          count:cells().length,
          horizontal:false
        };
      }, {passive:true});
      carousel.addEventListener('touchmove', event => {
        if (boundarySwipe) {
          if (event.cancelable) event.preventDefault();
          return;
        }
        if (!start) return;
        if (event.touches.length !== 1) { start = null; return; }
        const dx = event.touches[0].clientX - start.x;
        const dy = event.touches[0].clientY - start.y;
        if (!start.horizontal) {
          if (Math.max(Math.abs(dx),Math.abs(dy)) < 8) return;
          if (Math.abs(dy) > Math.abs(dx)) { start = null; return; }
          start.horizontal = true;
        }
        const forward = getComputedStyle(carousel).direction === 'rtl' ? dx > 0 : dx < 0;
        if ((forward && start.last) || (!forward && start.first)) {
          if (event.cancelable) event.preventDefault();
          if (Math.abs(dx) >= 24) {
            boundarySwipe = true;
            start = null;
            wrap(forward ? 0 : cells().length - 1,forward ? 1 : -1);
          }
        }
      }, {passive:false,capture:true});
      carousel.addEventListener('touchcancel', () => { start = null; boundarySwipe = false; }, {passive:true});
      carousel.addEventListener('touchend', event => {
        if (boundarySwipe) {
          boundarySwipe = false;
          start = null;
          if (event.cancelable) event.preventDefault();
          return;
        }
        const gesture = start;
        start = null;
        if (!gesture || event.touches.length || !event.changedTouches.length ||
            gesture.count !== cells().length) return;
        const dx = event.changedTouches[0].clientX - gesture.x;
        const dy = event.changedTouches[0].clientY - gesture.y;
        if (Math.abs(dx) < 24 || (!gesture.horizontal && Math.abs(dx) < Math.abs(dy) * 1.2)) return;
        const forward = getComputedStyle(carousel).direction === 'rtl' ? dx > 0 : dx < 0;
        if ((forward && gesture.last) || (!forward && gesture.first)) {
          wrap(forward ? 0 : cells().length - 1,forward ? 1 : -1);
        }
      }, {passive:false});
    });
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initialise, {once:true});
  else initialise();
  document.addEventListener('shopify:section:load', initialise);
  document.addEventListener('product:rerender', initialise);
})();
  } catch(e) { console.error(e); }
})();

})();
